import React,{useState,useEffect,Fragment} from 'react'

import {Card,Button,Image,Grid,Placeholder } from 'semantic-ui-react'



function Cards(props) {

    const [loading, setLoading] = useState(false)

    const onload=()=>{
        setLoading(true)
        setTimeout(() => {
            setLoading(false)
        }, 4000);
    }

    useEffect(() => {
        onload()    
        return (
            onload()
        )     
    }, [])
    
    return (
        <Grid.Column mobile={8} tablet={5} computer={4}>
            <Card color={props.color}>
            {
                loading ? 
                <Placeholder>
                <Placeholder.Image square ></Placeholder.Image>
                </Placeholder>
                :
            <Image src={props.src} />
            }

            {
                loading ? 
                <Fragment>

                <Card.Content textAlign="center">
                <Placeholder >
                <Placeholder.Header>
                <Placeholder.Line  />
                </Placeholder.Header>
                </Placeholder>
                </Card.Content>
                <Card.Content textAlign="center" extra>   
                <Button disabled={loading}  inverted color="violet" size="tiny">Explore</Button>
                </Card.Content>     
                </Fragment>
                
                :
                <Fragment>
                <Card.Content  textAlign="center">
                <Card.Header  >
                {props.serviceName}
                </Card.Header>
                </Card.Content>
                <Card.Content textAlign="center" extra>   
                <Button onClick={props.view} disabled={loading}  inverted color="violet" size="tiny">Explore</Button>
                </Card.Content>     
                </Fragment>
            }
        </Card>                        
        </Grid.Column>
    )
}

export default Cards
